import log from 'loglevel';
import { TABLE } from '../../../consts';
import SocialPublic from '../../../icons/public';
import { MatchStatusEnum } from '../../../consts/enums';
import { PERMISSIONS } from '../../../consts/permissions';
import { useAuth } from '../../../hooks/useAuth';
import { ActionMenu } from './ActionMenu';

const TAG = 'MATCH_ACTION_MENU';

const publishedActions = [
  {
    type: TABLE.ACTIONS.CHANGE_STATUS,
    title: 'Back to draft (Unpublish)',
    icon: <SocialPublic />,
    permissions: [PERMISSIONS.MATCH_EDIT],
  },
];

type MatchActionMenuProps = {
  id: string,
  onChangeStatus:() => void,
  status: string,
}

export const MatchActionMenu = ({
  id,
  onChangeStatus,
  status,
}: MatchActionMenuProps):JSX.Element | null => {
  const { hasPermissions } = useAuth();

  const actionsPublished = publishedActions.filter((action) => {
    return !action.permissions || hasPermissions(action.permissions);
  }).map((action) => ({
    ...action,
    key: id,
  }));

  const actions = status ===  MatchStatusEnum.published ? actionsPublished : undefined;

  if (!actions || actions.length <= 0) {
    return null;
  }

  const handleActions = (key: string, type: string) => {
    switch (type) {
      case TABLE.ACTIONS.CHANGE_STATUS: {
        onChangeStatus();
        break;
      }
      default:
        log.warn(TAG, `Cannot find any handler for type: ${type}`);
    }
  };

  return (
    <ActionMenu
      actions={ actions }
      handleActions={ handleActions }
    />
  );
};
